import React, { FC } from 'react'
import { Row, Col, Form, Card, Button } from 'react-bootstrap'
import { Formik } from 'formik'
import { OrganizationalInfoSchema } from '../../../../utils/validation'
import { isEmpty } from 'lodash'

interface Props {
  initialValues: any;
  readonly: boolean;
  handleNext: (values: any) => void;
  handleBack: (values: any) => void;
  onSubmit: (values: any) => void;
}

const OrganizationalInfo: FC<Props> = ({ initialValues, readonly, handleNext, handleBack, onSubmit }: Props) => {

  return (
    <div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={OrganizationalInfoSchema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false)
          onSubmit(values)
        }}
      >
        {({ errors, isValid, values, handleChange, handleSubmit, validateForm }) => {
          const handleNextClicked = async () => {
            const foundErrors = await validateForm()
            if (isEmpty(foundErrors)) {
              handleNext(values)
            }
          }

          return (
            <Form noValidate onSubmit={handleSubmit}>
              <Card>
                <Card.Body style={{ background: '#f7f7f7' }}>
                  <Card.Title>Organization Information</Card.Title>
                  <Row>
                    <Form.Group as={Col} xs={12}>
                      <Form.Label>Describe your organization&#8217;s cultural competency.</Form.Label>
                      <Form.Control
                        as='textarea'
                        rows={4}
                        name='culturalCompetency'
                        placeholder='Please provide a complete description.'
                        value={values.culturalCompetency}
                        isInvalid={!!errors.culturalCompetency}
                        onChange={handleChange}
                        disabled={readonly}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.culturalCompetency}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <hr />
                  <Row>
                    <Form.Group as={Col} xs={12}>
                      <Form.Label>Describe any potential service limitations related to the services you are applying for.</Form.Label>
                      <Form.Control
                        as='textarea'
                        rows={4}
                        name='serviceLimitations'
                        placeholder='Please provide a complete description.'
                        value={values.serviceLimitations}
                        isInvalid={!!errors.serviceLimitations}
                        onChange={handleChange}
                        disabled={readonly}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.serviceLimitations}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <hr />
                  <Row>
                    <Form.Group as={Col} xs={12}>
                      <Form.Label>Describe your organization&#8217;s Quality Improvement/Quality Assurance Plan.</Form.Label>
                      <Form.Control
                        as='textarea'
                        rows={4}
                        name='qualityAssurancePlan'
                        placeholder='Please provide a complete description.'
                        value={values.qualityAssurancePlan}
                        isInvalid={!!errors.qualityAssurancePlan}
                        onChange={handleChange}
                        disabled={readonly}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.qualityAssurancePlan}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <hr />
                  <Row>
                    <Form.Group as={Col} xs={12}>
                      <Form.Label>Describe your training plan/schedule for your staff (if applicable).</Form.Label>
                      <Form.Control
                        as='textarea'
                        rows={4}
                        name='trainingPlan'
                        placeholder='Please provide a complete description'
                        value={values.trainingPlan}
                        isInvalid={!!errors.trainingPlan}
                        onChange={handleChange}
                        disabled={readonly}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.trainingPlan}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <hr />
                  <Row>
                    <Form.Group as={Col} xs={12}>
                      <Form.Label>Describe the pay levels and benefits provided for your direct care staff (if applicable).</Form.Label>
                      <Form.Control
                        as='textarea'
                        rows={4}
                        name='payLevelsAndBenefits'
                        placeholder='Please provide a complete description'
                        value={values.payLevelsAndBenefits}
                        isInvalid={!!errors.payLevelsAndBenefits}
                        onChange={handleChange}
                        disabled={readonly}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.payLevelsAndBenefits}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <hr />
                  <Row>
                    <Form.Group as={Col} xs={12}>
                      <Form.Label>Describe your organization&#8217;s policy/process for identifying, reporting, evaluating, and resolving unintended events.</Form.Label>
                      <Form.Control
                        as='textarea'
                        rows={4}
                        name='unintendedEventsPolicy'
                        placeholder='Please provide a complete description'
                        value={values.unintendedEventsPolicy}
                        isInvalid={!!errors.unintendedEventsPolicy}
                        onChange={handleChange}
                        disabled={readonly}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.unintendedEventsPolicy}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <hr />
                  <Row>
                    <Form.Group as={Col} xs={12}>
                      <Form.Label>Please indicate the length of time your agency has been in business providing the service for which you are applying:</Form.Label>
                      <Form.Control
                        as='textarea'
                        rows={4}
                        name='businessYears'
                        placeholder='Please provide a complete description'
                        value={values.businessYears}
                        isInvalid={!!errors.businessYears}
                        onChange={handleChange}
                        disabled={readonly}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.businessYears}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 15 }}>
                {
                  !readonly ? (
                    <Button
                      type='submit'
                      variant='secondary'
                      style={{ width: '115px'}}
                    >
                      Save & Exit
                    </Button>
                  ) : null
                }
                <div>
                  <Button
                    variant='secondary'
                    style={{ width: '115px', marginRight: 10 }}
                    onClick={() => handleBack(values)}
                  >
                  Previous
                  </Button>
                  <Button
                    variant='info'
                    style={{ width: '115px', marginRight: 10 }}
                    onClick={() => handleNextClicked()}
                    disabled={!isValid}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}

export default OrganizationalInfo